import { getFirestore, type Firestore } from "firebase/firestore";

import { getFirebaseApp } from "@/lib/firebase/app";

let db: Firestore | undefined;

export function getFirestoreDb(): Firestore {
  if (!db) {
    db = getFirestore(getFirebaseApp());
  }
  return db;
}
